import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'blogs';
export const BLOGSPAGE_POSTS_SECTION_NAME = 'BlogsSection';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { blogs: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
